var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0406 3.2615L21.7562 18.6973C22.5147 20.2147 21.4116 22 19.7156 22H4.28435C2.58839 22 1.48534 20.2147 2.2438 18.6973L9.95944 3.26151C10.8002 1.5795 13.1998 1.5795 14.0406 3.2615ZM13.4985 9.04479L8.03109 14.3445C7.96572 14.4079 8.00839 14.4999 8.11271 14.5205L11.4163 15.1729C11.4974 15.1889 11.5455 15.2503 11.5237 15.3101L10.2338 18.8584C10.1907 18.9771 10.4006 19.053 10.5015 18.9552L15.9689 13.6555C16.0343 13.5921 15.9916 13.5001 15.8873 13.4795L12.5837 12.8271C12.5026 12.8111 12.4545 12.7497 12.4763 12.6899L13.7662 9.14156C13.8093 9.02293 13.5994 8.94703 13.4985 9.04479Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.7ed10ae8639ce57bfb299e95f891cf79.svg";
export { ForwardRef as ReactComponent };